export enum BackofficeRoutes {
  ROOT = '/',
  PROJECTS = 'projects',
  REPORT_TEMPLATES = 'report-templates',
  ORGANIZATIONS = 'organizations',
  USERS = 'users',
  BEAMSTAR = 'beamstar',
}
